import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { borderRadius, color, marginAttributes, paddingAttributes, sizeAttributes } from '../../system';
import { token } from '../../system/mixins';
import { getPropsBlocker } from '../../utils';
export var CardRoot = styled.div.withConfig(getPropsBlocker())(_templateObject(), color('neutral.00'), borderRadius('soft'), token('elevation.small'), marginAttributes, paddingAttributes, sizeAttributes);